export default {"src":"/_next/static/media/white-desktop-logo.09436738.svg","height":40,"width":220,"blurWidth":0,"blurHeight":0};